/** Passed to `onUploadFiles(..., folderKey, ...)` for drag/drop and file input at KB root (`parent_id` null). */
export const KB_ROOT_UPLOAD_FOLDER_KEY = '__KB_ROOT__';
